import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { ALL_DAY, DAYS } from '../../../../../constants/restaurantConst';

const RestaurantHours = ({ restaurantHours }) => {
  const [selectedDays, setSelectedDays] = useState([]);
  useEffect(() => {
    const daysToMap = formatArrayForDisplay(restaurantHours);
    setSelectedDays(daysToMap);
  }, []);

  const formatArrayForDisplay = (selectedDay) => {
    const daysToReturn = [];
    let daysList = [...selectedDay];
    while (daysList.length > 0) {
      const firstObject = daysList[0];
      const filteredRows = daysList.filter(
        (dayKey) => dayKey.open === firstObject.open && dayKey.close === firstObject.close,
      );
      daysToReturn.push({
        day: filteredRows.map((filteredRowDaysName) => filteredRowDaysName.day),
        open: filteredRows[0].open,
        close: filteredRows[0].close,
      });
      const tempDaysList = [...daysList];
      filteredRows.forEach((filteredRowsItem) => {
        const findFilteredDayIndex = tempDaysList.findIndex(
          (tempDaysListItem) => tempDaysListItem.day === filteredRowsItem.day,
        );
        tempDaysList.splice(findFilteredDayIndex, 1);
      });
      daysList = [...tempDaysList];
    }
    return daysToReturn;
  };

  const daysConteniousCheck = (days) => {
    const firstIndex = DAYS.findIndex((day) => day.name.toLowerCase() === days[0].toLowerCase());
    for (let i = 0; i < days.length; i++) {
      if (days[i].toLowerCase() !== DAYS[(i + firstIndex) % 7].name.toLowerCase()) return false;
    }
    return true;
  };

  const renderDays = (days) => {
    if (days.length > 2) {
      const areDaysContenious = daysConteniousCheck(days);
      if (areDaysContenious) {
        const tempdays = [days[0], days[days.length - 1]];
        return tempdays
          .map((tempDay) => tempDay.charAt(0).toUpperCase() + tempDay.slice(1, 3).toLowerCase())
          .join(' to ');
      }
      return days
        .map((day) => {
          if (day === 'EVERYDAY') return 'Everyday';
          return day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase();
        })
        .join(', ');
    } else {
      return days[0] === 'EVERYDAY'
        ? 'Everyday'
        : days.map((day) => day.charAt(0).toUpperCase() + day.slice(1, 3).toLowerCase()).join(', ');
    }
  };

  const changeTimeFormat = (open, close) => {
    return `${moment(open, 'HH:mm').format('LT')} - ${moment(close, 'HH:mm').format('LT')}`;
  };

  return (
    <>
      {selectedDays.length === 1 && selectedDays[0].day[0] === 'EVERYDAY' ? (
        <>
          <div className='row mt-4 mb-2 mx-4'>
            <div className='col-md-6'>
              <div className='details-label'>Available On</div>
              <div className='details-value'>EveryDay</div>
            </div>
          </div>
          <div className='row mt-4 mb-2  mx-4'>
            <div className='col-md-6'>
              <div className='details-label'>Hours</div>
              <div className='details-value'>
                {selectedDays[0].open === ALL_DAY
                  ? '24*7'
                  : changeTimeFormat(selectedDays[0].open, selectedDays[0].close)}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className='row mt-4 mb-2  mx-4'>
          {selectedDays.length !== 0 && (
            <div className='col-md-12'>
              <div className='details-label'>Open On</div>
              <div className='details-value'>
                {selectedDays.map((timing, timeNdx) => (
                  <div className='row' key={timeNdx}>
                    <div className='col-md-12 text'>
                      {renderDays(timing.day)} :{' '}
                      {timing.open === ALL_DAY
                        ? ALL_DAY
                        : changeTimeFormat(timing.open, timing.close)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {selectedDays.length === 0 && (
            <div className='col-md-12'>
              <div className='details-label'> No hours details available</div>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default RestaurantHours;
